var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEqual = function SvgEqual(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "equal_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#equal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 17q-.625 0-1.062-.437A1.45 1.45 0 0 1 4 15.5q0-.625.438-1.062A1.45 1.45 0 0 1 5.5 14h13q.625 0 1.063.438.437.437.437 1.062 0 .624-.437 1.063A1.45 1.45 0 0 1 18.5 17zm0-7q-.625 0-1.062-.437A1.45 1.45 0 0 1 4 8.5q0-.625.438-1.062A1.45 1.45 0 0 1 5.5 7h13q.625 0 1.063.438Q20 7.875 20 8.5q0 .624-.437 1.063A1.45 1.45 0 0 1 18.5 10z"
  }))));
};
export default SvgEqual;